import { addProp } from "@pnp/odata";
import { _Site } from "../sites/types.js";
import { UserCustomActions } from "./types.js";
addProp(_Site, "userCustomActions", UserCustomActions);
//# sourceMappingURL=site.js.map